module.exports = __webpack_public_path__ + "img/paper-card.a54d51d0.svg";